<template>
  <div class="row response_table">
     <table>
      <thead>
        <tr>
          <th>{{ translate('task.name_task') }}</th>
          <th>{{ translate('task.count_mm') }}</th>
          <th>{{ translate('task.status') }}</th>
          <th>{{ translate('task.username') }}</th>
          <th>{{ translate('task.ts') }}</th>
        </tr>
      </thead>
      <tbody ref="tableTask" >
        <tr v-for="(task, key) in tasks" :key="key">
          <td :data-label="translate('task.name_task')">
            {{ task.name }}
          </td>
          <td :data-label="translate('task.count_mm')">
            {{ task.count }}
          </td>

          <td :data-label="translate('task.status')">
            {{ task.status }}
          </td>
          <td :data-label="translate('task.username')">
            <router-link :to="{path: '/user/' + task.user_name}" class="link">
              {{ task.user_name }}
            </router-link>
          </td>
          <td :data-label="translate('task.ts')">
            {{ get_date(task.ts_create) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: 'MassRPCTasks',
  data () {
    return {
      tasks: [],
    }
  },
  created () {
    this.getMassRPCTasks()
  },
  methods: {
    getMassRPCTasks(){
      this.$http.v1.getMassRPCIndex((response) => {
        if (response.data){
          this.tasks = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
  }
}

</script>
<style>

</style>
